<template>
    <div v-if="!state.loading">
        <h2>{{page.title}} <br/>
            <small>({{page.subject}})</small>
        </h2>
        <div class="writearea">
            <div class="qwrap" v-for="(row, rowIndex) in list" :key="rowIndex">
                <p style="font-size: 14px; font-weight: bold; margin:0;">Question {{row.sn}}</p>
                <div style="font-size: 16px;" v-html="row.question"></div>
                <EditorView  v-model="qanswer[row.id]"/>
            </div>
        </div>
        <button class="btn-primary" @click="submitAnswers">
            Submit Answers
        </button>
    </div>
    <div v-else class="loader">
        <img src="@/assets/img/ajldr.gif" />
    </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, computed,ref} from 'vue';
import { useRoute, useRouter } from "vue-router";
import EditorView from '@/components/EditorView.vue'

export default {
    name:"AssignmentView",
    components:{EditorView},
    setup(){
        const qanswer=ref({})
        const route = useRoute();
        const id = computed(() => route.params.id)
        const page=reactive({title:"",subject:""});
        const state=reactive({loading:true})
        const list = ref([])
        const router = useRouter();

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }
        
        onMounted(() => {
            call({
                url:urls.student,
                data:{getAssignmentQuestions:id.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        page.title=res.msg.title;
                        page.subject=res.msg.subject;
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function submitAnswers(){
            const data={"answerAssignment":id.value,"answers":qanswer.value}
            state.loading=true;
            call({
                url:urls.student,
                data:data,
                success:(res)=>{
                    state.loading=false;
                    if(res.status){
                        alert(res.msg)
                        router.push({ name: 'assignmentlist'});
                    }else{
                        alert(res.msg)
                    }
                }
            })
            console.log(qanswer.value);
        }

        return {page, state,list, qanswer,submitAnswers}
    }
}
</script>

<style>
h2{font-size: 22px; line-height: 1em;}
h2 small{color: #3c8dbc;}
.qwrap{margin-bottom:10px}
.writearea{margin-top:15px}
</style>